import React from "react";

// Reusable skeleton-wave loader.
// Uses width/height utility classes via `dimensions`
// so it adapts nicely inside buttons, inline content, or blocks.
function Loader({ dimensions = "w-7 h-7", className = "" }) {
  return (
    <div
      role="status"
      className={`inline-block bg-gray-300 rounded skeleton-wave ${dimensions} ${className}`}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default Loader;
